export default __webpack_public_path__ + "static/media/gmp.0b9f8b29.png";